import { AuditScoreBadgeController } from './audit-score-badge.controller'

function auditScoreBadge () {
  return {
    restrict: 'E',
    scope: {
      status: '<',
      score: '<'
    },
    templateUrl: '/audit/directives/audit-score-badge/audit-score-badge-directive.html?$$REVISION$$',
    controller: AuditScoreBadgeController
  }
}

export { auditScoreBadge }
